import Modal from "./Modal";
import QuoteForm from "./QuoteForm";

export default function QuoteDialog({ open, onOpenChange }) {
  return (
    <Modal
      testId="quote-dialog"
      open={open}
      onOpenChange={onOpenChange}
      title="Request a Quote"
      subtitle="Tell us what you need and we will get right back to you. No pressure, just honest help."
    >
      <QuoteForm idPrefix="modal-quote" onDone={() => {}} />
    </Modal>
  );
}
